import { fgFilterEntries } from "@redotech/redo-fulfillment-operations-common/views/fulfillment/fg-filter-catalog";
import FulfilledByIcon from "@redotech/redo-icons/building-01.svg";
import { ArrayStringFilterOperator } from "@redotech/redo-views-common/advanced-filters/array-string-filter";
import { ArrayStringTableFilter } from "@redotech/redo-web/advanced-filters/advanced-filter";

const entry = fgFilterEntries.fulfilledBy;

export const FulfilledByArrayFilter: ArrayStringTableFilter<string> = {
  type: entry.type,
  Icon: FulfilledByIcon,
  operators: [...entry.operators],
  data: {
    name: entry.name,
    type: entry.type,
    value: [],
    operator: ArrayStringFilterOperator.ANY_OF,
  },
  itemLabel: "party",
  itemLabelPlural: "parties",
  values: [...entry.staticValues],
  displayName: entry.displayName,
};
